import { postupConstants } from '../constants/postupConstants';

const initialState = {
	error: {},
	postupResponse: {},
	postupDetail: {},
	listPostup: {},
};

export default function postupReducer(state= initialState, action) {
	switch (action.type) {
		case postupConstants.POSTUP_REQUEST:
		return {
			sending: true
		};
		case postupConstants.POSTUP_SUCCESS:
		return {
			...state,
			sending: false,
			postupResponse: action.data
		};
		case postupConstants.POSTUP_FAILURE:
		return {
			...state,
			sending: false,
			error: action.error
		};
		case postupConstants.GET_POSTUP_REQUEST:
		return {
			sending: true
		};
		case postupConstants.GET_POSTUP_SUCCESS:
		return {
			...state,
			sending: false,
			postupDetail: action.data
		};
		case postupConstants.GET_POSTUP_FAILURE:
		return {
			...state,
			sending: false,
			error: action.error
		};
		case postupConstants.LIST_POSTUP_REQUEST:
	      return {
	        sending: true
	      };
	    case postupConstants.LIST_POSTUP_SUCCESS:
	      return {
	        ...state,
	        sending: false,
	        listPostup: action.data
	      };
	    case postupConstants.LIST_POSTUP_FAILURE:
	      return {
	        ...state,
	        sending: false,
	        error: action.error
	      }; 
		default:
		return state
	}
}


// WEBPACK FOOTER //
// ./src/app/redux/reducers/postupReducer.js